import { Component, Vue, Watch } from 'vue-property-decorator'
import { PermissionModule } from '@/store/modules/permission'
@Component({ name: 'PageSideBar' })
export default class PageSideBar extends Vue {
  private sourceData = []

  created () {
    this.generateRouterData()
  }

  @Watch('$route')
  routerChange (data: any) {
    this.generateRouterData()
  }

  /**
   *  生成路由节点
   */
  private generateRouterData () {
    const routes = JSON.parse(JSON.stringify(PermissionModule.dynamicRoutes))
    const rd: any = routes[0].children
    const mainList = rd.filter((item: any) => { return item.meta && item.meta.menu })
    // 赋予初始值，当前节点是否需要展开
    const initData: any = this.$route.matched.map((item: any) => { return item.meta.name }).filter((item: any) => { return item })
    mainList.map((item: any) => { item = this.checkInitialData(initData, item); return item })
    mainList.forEach((value: any, index: any, array: any) => { if (value.children && value.children.length > 0) { array[index].children = value.children.map((child: any) => { child = this.checkInitialData(initData, child); return child }) } })
    this.sourceData = mainList
  }

  /**
   * 检查初始状态
   */
  private checkInitialData (source: any, target: any) {
    if (source.length === 1) {
      source = source[0]
      target.choosed = source === target.meta.name
      target.opened = false
    } else if (source.length === 2) {
      const level1 = source[0]
      const level2 = source[1]
      target.opened = level1 === target.meta.name
      target.choosed = level2 === target.meta.name
    }
    return target
  }

  /**
   *  检查当前路由节点是否有需要显示出来的子路由
   */
  private checkHaveChildItem (item: any) {
    if (item.children) {
      const list: any = item.children
      const childList = list.filter((item: any) => { return item.meta && item.meta.menu })
      return childList.length > 0
    } else {
      return false
    }
  }

  /**
   * 最外层导航被点击, 当有子节点的时候，为打开操作；当没有子节点的时候，为选中操作。
   */
  private onTopItemClick (item: any) {
    if (item.children && item.children.length > 0) {
      item.opened = !item.opened
    } else {
      this.clearAllChooseState()
      item.choosed = true
      this.$router.push(`/${item.path}`)
    }
  }

  /**
   *  清除所有的选中状态
   */
  private clearAllChooseState () {
    this.sourceData.forEach((value, index, array: any) => {
      array[index].choosed = false
      if (array[index].children && array[index].children.length > 0) {
        array[index].children.forEach((cvalue: any, cindex: string, carray: any) => {
          carray[cindex].choosed = false
        })
      }
    })
  }

  /**
   * child 菜单被点击触发的回调函数
   */
  private onChildItemClick (item: any, childrenItem: any, topIndex: any, childIndex: any) {
    this.clearAllChooseState()
    const buffer: any = JSON.parse(JSON.stringify(this.sourceData))
    buffer[topIndex].children[childIndex].choosed = true
    this.sourceData = buffer
    this.$router.push(`/${item.path}/${childrenItem.path}`)
  }
}
